import { Box } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";

import getRedirectUrl from "../helper/getRedirectUrl";
import { theme } from "../mui-customs/Theme";
import { setHostPath } from "../redux/appSlice";
import BottomNavbar from "./BottomNavbar";
import Footer from "./footer";
import PopupWrapperComponent from "./popup/PopupWrapperComponent";
import TopBar from "./topBar/TopBar";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const dispatch = useDispatch();
  useEffect(() => {
    const baseUrl = getRedirectUrl();
    dispatch(setHostPath(baseUrl));
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TopBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: { md: 10 },
          backgroundColor: theme.grey2[50],
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PopupWrapperComponent />

        {children}
      </Box>
      <Footer />
      <BottomNavbar
        sx={{
          position: "fixed",
          zIndex: 999,
          bottom: "0px",
        }}
      />
    </Box>
  );
}
